import React, { useState } from 'react';
import GPSStatusMappingModal from './GPSStatusMappingModal';

const SENTENCES = {
  received:
    "Vue centrée sur les tickets reçus pendant la période. Les indicateurs d'encours et l'ancienneté du backlog sont masqués — non pertinents pour un flux entrant.",
  resolved:
    "Vue centrée sur les tickets fermés pendant la période. L'encours et l'ancienneté du backlog sont masqués — non pertinents pour un flux sortant.",
  ongoing:
    "Photo du backlog ouvert au dernier jour de la période. Les mouvements (reçus / fermés) sont masqués ; l'ancienneté du backlog est mise en avant.",
  all:
    "Mode « Tout » : flux de la période (reçus, fermés) ET encours au dernier jour de la période, présentés dans des blocs distincts ci-dessous.",
};

/**
 * Body notice for the Général tab: explains what the "Afficher" sense shows
 * (flux vs encours) + a link to the status mapping. Rendered in the page body
 * (not in the filters card) so it informs without taking filter-bar space.
 */
const GPSSenseNotice = ({ sense, message }) => {
  const [statusInfoOpen, setStatusInfoOpen] = useState(false);

  return (
    <div className="flex items-start gap-2 rounded-xl border border-[#e6e3fb] dark:border-gray-800 bg-[#faf9ff] dark:bg-[#1a1726] px-4 py-2.5 text-xs text-gray-600 dark:text-gray-300">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#5b3df0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mt-0.5 flex-shrink-0">
        <circle cx="12" cy="12" r="10" /><path d="M12 16v-4" /><path d="M12 8h.01" />
      </svg>
      <p className="leading-relaxed">
        <span className="font-semibold">{message || SENTENCES[sense] || SENTENCES.all}</span>{' '}
        <button
          type="button"
          onClick={() => setStatusInfoOpen(true)}
          className="font-semibold text-[#5b3df0] dark:text-[#a98ff5] hover:underline whitespace-nowrap"
        >
          En savoir plus sur les statuts
        </button>
      </p>
      <GPSStatusMappingModal isOpen={statusInfoOpen} onClose={() => setStatusInfoOpen(false)} />
    </div>
  );
};

export default GPSSenseNotice;
